import React from 'react';
import { alpha, styled, useTheme } from '@mui/material/styles';
import {AppBar, Toolbar, IconButton, Typography, Box, List, ListItemIcon, ListItemText, Drawer, ListItemButton} from '@mui/material';
import { Menu } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { setPage } from '../../storeredux';

const Title = styled(Typography)(({theme}) => ({
  display: 'none',
  fontFamily: 'Candara',
  [theme.breakpoints.up(320)]: {
    display: 'block',
  }}));

export default function Header(props) {
  const {path1,path2,icon1,icon2,desc1,desc2} = props
  const[anchor,setAnchor] = React.useState(null);
  const theme = useTheme()
  const dispatch = useDispatch()

  const handleMenuOpen = (event) => {
    setAnchor(event.currentTarget);
  }

  const handleMenuClose = () => {
    setAnchor(null);
  }

  const handleHome = (event) => {
    dispatch(setPage(path1))
    if(Boolean(anchor))
      return handleMenuClose();
  }

  const handleInfoDev = (event) => {
    dispatch(setPage(path2))
    if(Boolean(anchor))
      return handleMenuClose();
  }

  const menuId2 = "dev-menu";
  const renderMenuDev = (
     <List>
      <ListItemButton onClick={handleHome}>
        <ListItemIcon color="inherit">
         {icon1}
        </ListItemIcon>
        <ListItemText>{desc1}</ListItemText>
      </ListItemButton>
      <ListItemButton onClick={handleInfoDev}>
        <ListItemIcon color="inherit">
          {icon2}
        </ListItemIcon>
        <ListItemText>{desc2}</ListItemText>
      </ListItemButton>
     </List>
  );

  return(
    <AppBar sx={{backgroundColor: alpha("#00cc66", 0.7),maxWidth: '100vw',left:0}}>
      <Toolbar>
        <React.Fragment>
          <IconButton
            edge="start"
            sx={{marginRight: theme.spacing(2)}}
            aria-controls={menuId2}
            aria-haspopup="true"
            onClick={handleMenuOpen}
            color="inherit"
            aria-label="open drawer"
          >
            <Menu/>
          </IconButton>
          <Drawer anchor='left' open={Boolean(anchor)} onClose={handleMenuClose}>
            {renderMenuDev}
          </Drawer>
          <Box justifyContent='center' alignItems='center' display='flex' width='100%' paddingRight='50px'>
            <Title variant="body1" noWrap>
              <Typography component={'span'} variant='h6' sx={{color:'#b3ff66'}}><b>M</b></Typography>
              <Typography component={'span'} sx={{display:{xs:'none',sm:'inline-block'}}}>ahasiswa</Typography>
              <Typography component={'span'} variant='h6' sx={{color:'#b3ff66'}}> <b>P</b></Typography>
              <Typography component={'span'} sx={{display:{xs:'none',sm:'inline-block'}}}>ecinta</Typography>
              <Typography component={'span'} variant='h6' sx={{color:'#b3ff66'}}> <b>Q</b></Typography>
              <Typography component={'span'} sx={{display:{xs:'none',sm:'inline-block'}}}>ur`an</Typography>
              <Typography component={'span'} variant='h6' sx={{color:'#ffff00'}}>   <b>UMS</b></Typography>
            </Title>
          </Box>
        </React.Fragment>
      </Toolbar>
    </AppBar>
  )
}
